"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const HTMLDialogElementCompatibility_1 = require("@/client/components/HTMLDialogElementCompatibility");
const dialogPolyfill = require('dialog-polyfill');
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'ConfirmDialog',
    props: {
        message: {
            type: String,
            required: true,
        },
        enableDontShowAgainCheckbox: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            hide: false,
            shown: false,
        };
    },
    watch: {
        hide() {
            this.$emit('hide', this.hide);
        },
    },
    computed: {
        typedRefs() {
            return this.$refs;
        },
    },
    methods: {
        accept() {
            this.$emit('accept');
        },
        dismiss() {
            this.$emit('dismiss');
        },
        show() {
            this.shown = true;
            (0, HTMLDialogElementCompatibility_1.showModal)(this.typedRefs.dialog);
        },
    },
    mounted() {
        if (!(0, HTMLDialogElementCompatibility_1.windowHasHTMLDialogElement)())
            dialogPolyfill.default.registerDialog(this.typedRefs.dialog);
    },
});
